import { useContext } from "react"

// Context
import { UserContext } from "../../../../../context/userContext"

//PrimeReact
import { InputTextarea } from "primereact/inputtextarea"

//Google places
import { usePlacesWidget } from "react-google-autocomplete"

export default function QuestionInputAddress({
  question,
  value,
  onValueChange,
}) {
  const userCtx = useContext(UserContext)

  const googlePlacesApiKey = userCtx.keys.getGooglePlacesKey()

  const { ref } = usePlacesWidget({
    apiKey: googlePlacesApiKey,
    options: {
      types: ["geocode"],
      componentRestrictions: { country: "us" },
    },
    onPlaceSelected: (places) => {
      onValueChange(places.formatted_address)
    },
  })

  return (
    <InputTextarea
      ref={ref}
      className={"block"}
      style={{ width: "100%" }}
      value={value}
      onChange={(e) => {
        onValueChange(e.target.value)
      }}
      rows={question.height}
      autoResize
    />
  )
}
